import {
  SIDEBAR_COUNTS_FETCH_REQUEST,
  SIDEBAR_COUNTS_FETCH_SUCCESS,
  SIDEBAR_COUNTS_FETCH_FAILURE,
  INTERVIEW_VIEW_COUNTS_FETCH_SUCCESS,
} from '../actions/actionTypes';
import {
  SidebarCountsAction,
  SidebarCountsData,
  InterviewViewCountsData,
} from '../actions/sidebarCountsActions';

export interface SidebarCountsState {
  data: SidebarCountsData | null;
  /** Per-bucket Interviews sub-item counts, keyed by `?view=` preset. */
  interviewViewCounts: InterviewViewCountsData | null;
  loading: boolean;
  error: string | null;
}

const initialState: SidebarCountsState = {
  data: null,
  interviewViewCounts: null,
  loading: false,
  error: null,
};

export default function sidebarCountsReducer(
  state: SidebarCountsState = initialState,
  action: SidebarCountsAction,
): SidebarCountsState {
  switch (action.type) {
    case SIDEBAR_COUNTS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case SIDEBAR_COUNTS_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case SIDEBAR_COUNTS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case INTERVIEW_VIEW_COUNTS_FETCH_SUCCESS:
      return { ...state, interviewViewCounts: action.payload };
    default:
      return state;
  }
}
